import { Row, Col, Container } from 'react-bootstrap';

import MobileStoreButton from '../../../Components/MobileStoresButton';
import HeaderDevice1 from '../../../Assets/Images/header_device_1.svg';
import './style.scss';

const Header = () => {
  return (
    <header id='header' className='hero-section'>
      <div className='intro'>
        <div className='overlay'>
          <Container>
            <Row className='align-items-center min-vh-100 py-5'>
              <Col xs={12} md={6} lg={5} className='intro-text text-center text-md-start'>
                <div className='badge-pill mb-3'>
                  <span className='badge-text'>✨ The Future of Dining</span>
                </div>
                <h3 className='hero-title'>
                  A Smarter Way to
                  <span className='highlight-text'> Dine & Socialize</span>
                </h3>
                <p className='hero-description'>
                  Transform your dining experience with our innovative restaurant booking platform. 
                  Discover restaurants, peruse digital menu, and enjoy real time orders 
                  all in one smart mobile app.
                </p>
                <div className='plat-btn-container d-flex justify-content-center justify-content-md-start gap-3'>
                  <MobileStoreButton 
                    store='ios' 
                    url='#home' 
                    divClassName='plat-btn' 
                  />
                  <MobileStoreButton 
                    id='android-btn' 
                    store='android' 
                    url='#home' 
                    divClassName='plat-btn' 
                  />
                </div>
                {/* <div className='social-proof mt-5 d-flex flex-wrap gap-4 justify-content-center justify-content-md-start'>
                  <div className='stat-item'>
                    <div className='stat-icon'>🏪</div>
                    <div className='stat-content'>
                      <span className='stat-number'>1000+</span>
                      <span className='stat-label'>Partner Spots</span>
                    </div>
                  </div>
                  <div className='stat-item'>
                    <div className='stat-icon'>🎉</div>
                    <div className='stat-content'>
                      <span className='stat-number'>50K+</span>
                      <span className='stat-label'>Happy Ravers</span>
                    </div>
                  </div>
                  <div className='stat-item'>
                    <div className='stat-icon'>⭐</div>
                    <div className='stat-content'>
                      <span className='stat-number'>4.8</span>
                      <span className='stat-label'>App Rating</span>
                    </div>
                  </div>
                </div> */}
              </Col>
              <Col md={6} lg={7} className='devices order-1 order-md-2 text-center d-none d-md-block'>
                <div className='device-container position-relative'>
                  <div className='floating-card card-1'>
                    <div className='card-icon'>🍽️</div>
                    <div className='card-text'>Instant Orders</div>
                  </div>
                  <div className='floating-card card-2'>
                    <div className='card-icon'>💳</div>
                    <div className='card-text'>Secure Wallet</div>
                  </div>
                  <div className='floating-card card-3'>
                    <div className='card-icon'>⚡</div>
                    <div className='card-text'>Real-time Menu</div>
                  </div>
                  <img 
                    src={HeaderDevice1} 
                    alt="Smart dining app interface on mobile device showing restaurant booking and menu features"
                    className='img-fluid hero-device'
                    loading="eager"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </header>
  )
};

export default Header;